import { render, staticRenderFns } from "./BlogDetail.vue?vue&type=template&id=8cc97298&scoped=true&"
import script from "./BlogDetail.vue?vue&type=script&lang=js&"
export * from "./BlogDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetail.vue?vue&type=style&index=0&id=8cc97298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cc97298",
  null
  
)

export default component.exports